import { executeRequest, JFSRequest } from '@jfs/network'
import { getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

// TODO: update
const getRequestBody = (data: any) => {
  const request = {
    ruleName: data?.ruleName,
    payeeType: data?.payeeType,
    payeeUserId: data?.payeeUserId,
    payeeVpa: data?.payeeVpa,
    payerBankId: data?.payerBankId,
    binList: data?.binList,
    binRange: `${data?.binFrom},${data?.binTo}`,
    cardType: getIdFromMap(data?.cardType),
    scheme: getIdFromMap(data?.scheme),
    amount: `${data?.minAmount},${data?.maxAmount}`,
    transactionInitiatingEntityId: getIdFromMap(data?.transactionInitiatingEntityId),
    transactionApplication: data?.transactionApplication,
    txntype: getIdFromMap(data?.txntype),
    instrumentType: getIdFromMap(data?.instrumentType),
    mode: data?.mode,
    activationGroup: data?.activationGroup,
    priority: data?.priority,
    processor: data?.processor,
    isActive: data?.isActive === 'Enable' ? 'Y' : 'N',
  }
  console.log({ request })
  return request
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addRoutingRule = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.staticRoutingAdd),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addRoutingRule }
